<template>
  <v-card>
    <v-card-title class="grey lighten-5 headline">
      Templates Cadastrados
    </v-card-title>
    <v-row
      class="pa-4"
      justify="space-between"
      v-if="departamentoSelecionado === null"
    >
      <v-col cols="12">
        <h4>Selecione um Departamento para continuar</h4>
        <hr />
        <v-treeview
          :items="departamentos"
          :open.sync="open"
          activatable
          color="info"
          transition
        >
          <template v-slot:prepend="{ item, open }">
            <v-icon v-if="!item.file">
              {{ open ? "mdi-folder-open" : "mdi-file" }}
            </v-icon>
            <v-icon v-else>
              {{ files[item.file] }}
            </v-icon>
          </template>
          <template slot="label" slot-scope="{ item }">
            <a @click="selecionarDepartamento(item.id)">{{ item.name }}</a>
          </template>
        </v-treeview>
      </v-col>
    </v-row>
    <v-row v-if="departamentoSelecionado !== null">
      <v-col>
        <v-btn
          class="ma-2"
          outlined
          @click="limparDepartamento()"
          color="primary"
          ><i class="mr-1 fas fa-arrow-circle-left fa-2x"></i>
          Departamentos</v-btn
        >
      </v-col>
    </v-row>
    <hr />
    <v-row
      class="pa-4"
      justify="space-between"
      v-if="departamentoSelecionado !== null"
    >
      <v-col cols="4">
        <h3 class="mb-4">Departamento: {{ departamentoSelecionado.nome }}</h3>
        <v-btn
          v-if="verificarPermissao(permissoesPadrao.Incluir)"
          @click="novoRoot()"
          color="primary"
          >Novo Root</v-btn
        >
        <v-divider></v-divider>
        <v-treeview
          v-if="templates !== null && templates.length > 0"
          :items="templates"
          :open.sync="open"
          activatable
          color="info"
          transition
        >
          <template v-slot:prepend="{ item, open }">
            <v-icon v-if="!item.file">
              {{ open ? "mdi-folder-open" : "mdi-file" }}
            </v-icon>
            <v-icon v-else>
              {{ files[item.file] }}
            </v-icon>
          </template>
          <template slot="label" slot-scope="{ item }">
            <a @click="carregarDados(item)">{{ item.name }}</a>
          </template>
        </v-treeview>
      </v-col>

      <v-divider vertical></v-divider>

      <v-col cols="4" class="text-center">
        <v-scroll-y-transition mode="out-in">
          <div
            v-if="!template"
            class="title grey--text text--lighten-1 font-weight-light pt-6"
            style="align-self: center"
          >
            Selecione um Template
          </div>
          <v-card
            v-else
            :key="template.id"
            class="pt-6 mx-auto"
            flat
            max-width="400"
          >
            <v-card-text>
              <i class="fas fa-list fa-5x"></i>
              <h6 class="mb-2 mt-4">NOME DO TEMPLATE</h6>
              <h3 class="headline mb-2">
                {{ template.nome }}
              </h3>
            </v-card-text>
            <div v-if="template.id !== 0">
              <v-divider></v-divider>
              <v-card-actions class="justify-center">
                <v-btn
                  v-if="
                    template.templateSuperiorID == null &&
                    verificarPermissao(permissoesPadrao.Incluir)
                  "
                  color="info"
                  fab
                  x-small
                  dark
                  @click="novoCadastro()"
                  title="Novo Template Filho"
                  ><v-icon>mdi-plus</v-icon></v-btn
                >&nbsp;
                <v-btn
                  color="warning"
                  v-if="verificarPermissao(permissoesPadrao.Editar)"
                  fab
                  x-small
                  dark
                  @click="editar()"
                  title="Editar Dados Template"
                  ><v-icon>mdi-pencil</v-icon></v-btn
                >&nbsp;
                <v-btn
                  color="error"
                  v-if="verificarPermissao(permissoesPadrao.Excluir)"
                  fab
                  x-small
                  dark
                  @click="inativar()"
                  title="Excluir Template"
                  ><v-icon>mdi-trash-can</v-icon></v-btn
                >
              </v-card-actions>
            </div>
            <div v-if="novo || template.id === 0">
              <v-form v-model="valid" ref="form">
                <v-divider></v-divider>
                <h3
                  class="headline mb-2"
                  v-if="templateCadastro.id === 0 || template.id === 0"
                >
                  Cadastro de Template
                </h3>
                <h3 class="headline mb-2" v-else>Edição</h3>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="templateCadastro.nome"
                      label="Nome"
                      clearable
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-card-actions class="justify-center">
                  <v-btn
                    color="success"
                    fab
                    x-small
                    dark
                    :disabled="saving"
                    @click="salvar()"
                    title="Salvar"
                    ><i class="fas fa-save fa-2x"></i></v-btn
                  >&nbsp;
                </v-card-actions>
              </v-form>
            </div>
          </v-card>
        </v-scroll-y-transition>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col v-if="template">
        <h5>Documentos Vinculados</h5>
        <v-divider></v-divider>
        <v-expansion-panels>
          <v-expansion-panel v-for="grupo in grupos" :key="grupo.id">
            <v-expansion-panel-header v-if="grupo.documentos.length != 0">
              <v-row>
                <v-col cols="11">
                  {{ grupo.nome }}
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-if="grupo.documentos.length != 0">
              <v-row>
                <v-col cols="6" offset="6">
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Pesquisa"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-data-table
                :headers="headers"
                :items="grupo.documentos"
                :search="search"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td style="width: 10%">
                      <input
                        :disabled="item.documentoBloqueado"
                        type="checkbox"
                        v-model="item.atribuir"
                        @click="vincularDocumento(grupo.id, item.id)"
                      />
                    </td>
                    <td align="left">{{ item.nome }}</td>
                    <td align="left">{{ item.tipoDocumento }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <TelaLoading :overlay="saving"></TelaLoading>
  </v-card>
</template>

<script>
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import TelaLoading from "@/views/components/TelaLoading.vue";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";

export default {
  data: () => ({
    headers: [{ text: "" }, { text: "", value: "nome" }, { text: "", value: "tipo" }],
    grupos: [],
    search: "",
    valid: false,
    saving: false,
    permissoesPadrao: {},
    templates: [],
    templateDocumentos: [],
    cliente: {},
    template: null,
    templateCadastro: {
      id: 0,
      templateSuperiorID: null,
      departamentoID: 0,
      nome: "",
    },
    open: ["public"],
    rules: {
      required: (v) => !!v || "Obrigatório",
    },
    novo: false,
    departamentoSelecionado: null,
    departamentos: [],
  }),
  components: {
    TelaLoading,
  },
  methods: {
    novoRoot() {
      this.template = {
        id: 0,
        templateSuperiorID: null,
        clienteID: this.cliente.id,
        nome: "",
      };
    },

    carregarDados(item) {
      this.novo = false;
      this.buscarTemplate(item.id);
      this.buscarDocumentosVinculadosTemplate(item.id);
    },

    buscarTemplate(id) {
      return new Promise((resolve) => {
        ApiService.get("template/" + id).then(({ data }) => {
          resolve(data);

          if (data.success) this.template = data.data;
          else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },

    async buscarDocumentosVinculadosTemplate(id) {
      const { data: result } = await ApiService.get(
        "templatedocumento/getbytemplateid/" + id
      );

      if (result.success) {
        this.templateDocumentos = result.data;
        this.vincularDocumentos();
      } else SweetAlert.sweetAlertError(result.errors);
    },

    vincularDocumentos() {
      if (this.templateDocumentos.length > 0) {
        for (let index = 0; index < this.grupos.length; index++) {
          const grupo = this.grupos[index];

          for (let j = 0; j < grupo.documentos.length; j++) {
            const x = grupo.documentos[j];

            let doc = this.templateDocumentos.find(
              (d) => d.documentoID == x.id
            );

            x.atribuir = doc !== undefined;
            x.documentoBloqueado =
              doc !== undefined ? doc.documentoBloqueado : false;
          }
        }
      } else {
        this.limparSelecaoDocumentos();
      }
    },

    async listaTemplates() {
      const { data: result } = await ApiService.get(
        "template/getbydepartamentoid/" + this.departamentoSelecionado.id
      );

      if (result.success) this.templates = result.data;
      else SweetAlert.sweetAlertError(result.errors);
    },

    async listaDepartamentos() {
      const { data: result } = await ApiService.get(
        "departamento/gettreeviewbyclienteid",
        this.cliente.id,
        { filtrarUsuario: true }
      );

      if (result.success) {
        this.departamentos = result.data;
        this.limparSelecaoDocumentos();
      } else SweetAlert.sweetAlertError(result.errors);
    },

    limparSelecaoDocumentos() {
      for (let index = 0; index < this.grupos.length; index++) {
        const grupo = this.grupos[index];

        for (let j = 0; j < grupo.documentos.length; j++) {
          const doc = grupo.documentos[j];

          doc.atribuir = false;
        }
      }
    },

    async listaDocumentos() {
      const { data: result } = await ApiService.get(
        "grupodocumento/getbyclienteid/" + this.cliente.id
      );

      if (result.success) {
        for (let index = 0; index < result.data.length; index++) {
          const grupo = result.data[index];

          let documentos = [];

          for (let j = 0; j < grupo.documentos.length; j++) {
            const documento = grupo.documentos[j];

            const doc = {
              id: documento.id,
              nome: documento.nome,
              atribuir: false,
              tipoDocumento: documento.tipoDocumentoNome
            };

            documentos.push(doc);
          }

          grupo.documentos = documentos;
        }

        this.grupos = result.data;
      } else SweetAlert.sweetAlertError(result.errors);
    },

    novoCadastro() {
      this.novo = true;
      this.limparCadastro();
    },

    limparCadastro() {
      this.templateCadastro.id = 0;
      this.templateCadastro.templateSuperiorID = null;
      this.templateCadastro.departamentoID = 0;
      this.templateCadastro.nome = "";
    },

    editar() {
      this.novo = true;
      this.templateCadastro = this.template;
    },

    async salvar() {
      let self = this;
      let response = null;

      if (this.$refs.form.validate()) {
        this.saving = true;

        if (this.templateCadastro.id === 0) {
          this.templateCadastro.templateSuperiorID =
            this.template.id === 0 ? null : this.template.id;
          this.templateCadastro.departamentoID =
            this.departamentoSelecionado.id;
          const { data: result } = await ApiService.post(
            "template/incluir",
            this.templateCadastro
          );

          response = result;
        } else {
          this.templateCadastro.departamento = null;
          this.templateCadastro.templateSuperior = null;
          const { data: result } = await ApiService.put(
            "template/" + this.templateCadastro.id,
            this.templateCadastro
          );

          response = result;
        }
        this.saving = false;
        if (!response.success) {
          SweetAlert.sweetAlertError(response);
          return;
        }

        Swal.fire({
          position: "center",
          icon: "success",
          title:
            this.templateCadastro.id === 0
              ? "Template Cadastrado com Sucesso!"
              : "Template Alterado com Sucesso!",
          showConfirmButton: false,
          timer: 1500,
        }).then(function () {
          self.template = null;
          self.novo = false;
          self.limparCadastro();
          self.listaTemplates();
        });
      }
    },

    inativar() {
      let self = this;

      Swal.fire({
        title: "Tem certeza que deseja excluir esse registro?",
        text: "Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode excluir!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.put("template/" + self.template.id + "/inativar").then(
              ({ data }) => {
                resolve(data);

                if (data.success === true) {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Template Inativado com Sucesso!",
                    showConfirmButton: false,
                    timer: 1500,
                  }).then(function () {
                    self.template = null;
                    self.listaTemplates();
                  });
                } else SweetAlert.sweetAlertError(result.errors);
              }
            );
          });
        }
      });
    },

    vincularDocumento(grupoID, documentoID) {
      const grupo = this.grupos.find((g) => g.id == grupoID);

      const atribuir = grupo.documentos.find(
        (x) => x.id === documentoID
      ).atribuir;

      if (atribuir) {
        return new Promise((resolve) => {
          ApiService.delete(
            "templatedocumento/" + this.template.id + "/" + documentoID
          ).then(({ data }) => {
            resolve(data);

            if (data.success === true) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Documento Desvinculado!",
                showConfirmButton: false,
                timer: 1500,
              });
            } else SweetAlert.sweetAlertError(data.errors);
          });
        });
      } else {
        return new Promise((resolve) => {
          ApiService.put("templateDocumento/VincularTemplateDocumento", {
            templateID: this.template.id,
            documentoID: documentoID,
          }).then(({ data }) => {
            resolve(data);
            if (data.success)
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Documento Atribuído com Sucesso!",
                showConfirmButton: false,
                timer: 1500,
              });
            else SweetAlert.sweetAlertError(data.errors);
          });
        });
      }
    },
    verificarPermissao(permissao) {
      return PermissoesService.verificarAcesso(Modulo.Template, permissao);
    },
    async selecionarDepartamento(depto) {
      this.limparSelecaoDocumentos();

      const { data: result } = await ApiService.get("departamento/" + depto);

      if (result.success) {
        this.departamentoSelecionado = result.data;
        this.templateCadastro.departamentoID = this.departamentoSelecionado.id;
        this.listaTemplates();
      } else SweetAlert.sweetAlertError(result.errors);
    },

    limparDepartamento() {
      this.departamentoSelecionado = null;
      this.template = null;
      this.templates = [];
    },
  },
  mounted() {
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.permissoesPadrao = Permissoes;
    this.listaDocumentos();
    this.listaDepartamentos();
  },
  created() {
    if (
      !PermissoesService.verificarAcesso(Modulo.Template, Permissoes.Visualizar)
    ) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
